import { useEffect, useState } from "react";
import { getThemeData, getTotalCountData, getTypologyData, getVisitorCount } from "../../../../services/CommonService";
import Swal from "sweetalert2";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const [count, setCount] = useState({});
  const [allData, setAllData] = useState({});
  const getVisitor = async () => {
    try {
      const response = await getVisitorCount();
      setCount(response?.data);
      const totalcount = await getTotalCountData();
      setAllData(totalcount?.data);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || error?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  useEffect(() => {
    getVisitor();
    fetchThemes();
    fetchTypologies();
  }, []);

  // New API calls for themes and typologies
  const fetchThemes = async () => {
    try {
      const response = await getThemeData();
      if (response.status === 200) {
        const sortedThemes = response.data.sort((a, b) => a.name?.localeCompare(b.name));
        localStorage.setItem('themeData', JSON.stringify(sortedThemes));
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || error?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const fetchTypologies = async () => {
    try {
      const response = await getTypologyData();
      if (response.status === 200) {
        const sortedTypologies = response.data.sort((a, b) => a.name?.localeCompare(b.name));
        localStorage.setItem('typologyData', JSON.stringify(sortedTypologies));
      }
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error?.response?.data?.message || error?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div>
      <div className="card adminCardHeader m-3">
        <h4 className="p-2">Dashboard</h4>
      </div>

      <div className="container adminDashboard py-4">
        <div className="row  g-4">
          <div className="col-md-4 d-flex">
            <div className="card text-center w-100 shadow rounded-4 bg-pink py-4">
              <div className="circle bg-pi me-3">
                <i className="bi-people-fill text-white"></i>
              </div>
              <h2 className="fw-bold text-dark">{count?.total_visits || 0}</h2>
              <p className="mb-0">Visitor Count</p>
            </div>
          </div>

          <div className="col-md-4 d-flex">
            <div className="card text-center w-100 shadow rounded-4 py-4 bg-mint">
              <div className="circle bg-mi me-3">
                <i className="bi-journal-bookmark-fill text-white"></i>
              </div>
              <div className="d-flex text-center justify-content-center">
                <div >
                  <h2 className="fw-bold text-dark">{allData?.total_publications || ''}</h2>
                  <p className="me-0"># Publications</p>
                </div>
                <span className="vr mx-2 align-self-stretch"></span>
                <div >
                  <h2 className="fw-bold text-dark">{allData?.total_publication_downloads || ''}</h2>
                  <p className="mb-0">Downloads &nbsp; &nbsp;&nbsp;&nbsp;</p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 d-flex">
            <div className="card text-center w-100 shadow rounded-4 py-4 bg-peach">
              <div className="circle bg-pe me-3">
                <i className="bi-calendar-event text-white"></i>
              </div>
              <div className="d-flex text-center justify-content-center">
                <div >
                  <h2 className="fw-bold text-dark">{allData?.total_events || ''}</h2>
                  <p className="me-0">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;# Events</p>
                </div>
                <span className="vr mx-2 align-self-stretch"></span>
                <div >
                  <h2 className="fw-bold text-dark">{allData?.unique_participants || ''}</h2>
                  <p className="mb-0">Registrations</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};
export default AdminDashboard;
